import { useState, useEffect } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import bank from '../../Images/img1.jpg'
// import manufacturing from '../../Images/img2.jpg'
// import facmanagement from '../../Images/img3.jpg'

import security from '../../Images/security.jpeg'
import manuafacturing from '../../Images/manufacturing.jpeg'

const testimonials = [
  {
    id: 1,
    name: "BFSI banking financial and insurance",
    position: "General Manager (FINCARE BANK LTD)",
    image: bank,
    text: "CriterionScreeners team has remained extremely loyal to us throughout our relationship. Whenever we require Report or support, we’ve found that they are our most supportive, responsive, accurate and timebound vendor.”“We’ve had great success since choosing CriterionScreeners. They made what we thought were unattainable promises in the beginning, but they’ve proven themselves by keeping those promises and delivering more than we ever expected.",
  },
  {
    id: 2,
    name: "Largest facility and security company",
    position: "HEAD HR-Large Security and Facility management company",
    image: security,
    text: "Choosing Criterion was one of the best decisions we made for our business. Their expertise and strategic guidance have been instrumental in achieving our goals.We have had the pleasure of collaborating with CriterionScreeners on multiple projects. Their team's expertise and reliability make them a trusted partner, and we look forward to continuing our successful partnership",
  },
  {
    id: 3,
    name: "Largest steel producer",
    position: "HR - Tata Steel",
    image: manuafacturing,
    text: "It's been several months since Tata Steel have been connected with Team Criterion for Background verification. Our Team has been interacting with CRITERIONSCREENERS for the verification of employees and others. I want to appreciate enthusiasm towards work and quick responsive approach. It's been a pleasure working together with CRITERIONSCREENERS.",
  },
];

function Layer6() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const getPrevIndex = () => {
    return currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1;
  };

  const getNextIndex = () => {
    return currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1;
  };

  return (
    <div className="bg-black select-none ">
      <h2 className="text-white mb-4 text-2xl font-thin text-center text-[28px] sm:text-[34px]">
        Voice of the{" "}
        <span className="text-[#b7372e] font-bold">Customers</span>
      </h2>
      <div className="min-h-screen bg-black flex items-center justify-center px-4 sm:px-8">
        <div className="relative w-full max-w-[1500px] h-[550px] sm:h-[600px]">
          {/* Previous Slide - Glass Effect */}
          <div className="absolute left-[2%] sm:left-[3%] top-1/2 -translate-y-1/2 w-[300px] h-[180px] sm:w-[460px] sm:h-[250px] transform scale-90 transition-all duration-500 backdrop-blur-lg bg-gradient-to-r from-black to-white rounded-2xl p-4 shadow-lg opacity-30">
            <img
              src={testimonials[getPrevIndex()].image}
              alt={testimonials[getPrevIndex()].name}
              className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl mx-auto object-cover mb-4"
            />
            <p className="text-black text-xs sm:text-sm text-center italic">
              {testimonials[getPrevIndex()].text}
            </p>
          </div>

          {/* Current Slide */}
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] sm:w-[750px] h-auto sm:h-[450px] min-h-[400px] transition-all duration-500 backdrop-blur-lg bg-white rounded-2xl shadow-xl p-8 flex flex-col sm:flex-row items-center z-20">

            <div className="w-full sm:w-1/3">
              <img
                src={testimonials[currentIndex].image}
                alt={testimonials[currentIndex].name}
                className="w-50 h-100 sm:w-50 sm:h-50 rounded-xl object-cover mx-auto mb-4 sm:mb-6"
              />
            </div>
            <div className="w-full sm:w-2/3 px-4 sm:px-6">
              <div className="flex items-center justify-center mb-2 sm:mb-4">
                <div className="text-blue-500 text-3xl sm:text-4xl">“</div>
              </div>
              <h3 className="text-red-500 font-bold text-[18px] sm:text-[24px] text-center sm:text-left">
                {testimonials[currentIndex].name}
              </h3>
              <p className="text-black text-sm sm:text-base mb-4 sm:mb-6 text-center sm:text-left text-[18px] sm:text-[26px]">
                {testimonials[currentIndex].text}
              </p>
              <p className="text-black text-xs sm:text-sm text-center sm:text-left text-[16px] sm:text-[22px]">
                {testimonials[currentIndex].position}
              </p>
            </div>
          </div>

          {/* Next Slide - Glass Effect */}
          <div className="absolute right-[2%] sm:right-[3%] top-1/2 -translate-y-1/2 w-[300px] h-[180px] sm:w-[460px] sm:h-[250px] transform scale-90 transition-all duration-500 backdrop-blur-lg bg-gradient-to-r from-white to-black rounded-2xl p-4 shadow-lg z-10 opacity-30">
            <img
              src={testimonials[getNextIndex()].image}
              alt={testimonials[getNextIndex()].name}
              className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl mx-auto object-cover mb-4"
            />
            <p className="text-white text-xs sm:text-sm text-center italic">
              {testimonials[getNextIndex()].text}
            </p>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-30 text-white hover:text-gray-300 transition-colors"
          >
            <FaArrowLeft className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-30 text-white hover:text-gray-300 transition-colors"
          >
            <FaArrowRight className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Layer6;
